module.exports = __webpack_public_path__ + "media/img/description/description-solution-after-a5e9a6a780a588c664f162e805f86b2b.svg";